<template>
  <div class="flex items-center justify-center h-screen">
    <p>Processing login...</p>
  </div>
</template>

<script setup>
</script>
